import { ContentLayout } from "../layout/ContentLayout";

export const NoPage = () => {
  return (
    <>
      <ContentLayout>Page not found</ContentLayout>
    </>
  );
};
